module.exports = __webpack_public_path__ + "static/media/mask.e641202f.png";